import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  meta: {
    count: 0,
    currentPage: 1,
  },
  records: {},
  sortOrder: [],
  // Every franchise the user can reach, for dropdowns that cannot be paginated.
  allFranchises: [],
  currentFranchise: {},
  selectedFranchiseIds: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  units: [],
  allUnits: [],
  attendants: [],
  uiFlagsUnits: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  uiFlagsAttendants: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
